import React from 'react';
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import {
    useSettingContextInComponent,
    useSettingsContext,
} from 'src/mtska-frontend-app-scaffolding';
import { DashboardFilterRenderer } from './filterRegistry';
import { useDashboardFiltersStorageKey } from './DashboardFiltersStorageKeyContext';

const DashboardPageTitle = ({
    title,
    dataProviderName,
    defaultFilters,
    pageFiltersConfig = [],
    filterSetName,
    filterCatalog,
    showFilterSetLabel = true,
    filterToolbarExtras = null,
    filterVisibilityUser = null,
    onClearFilters = null,
}) => {
    const { t } = useTranslation();
    const filtersStorageKey = useDashboardFiltersStorageKey(dataProviderName);
    const { filterModel, drawable } = useSettingContextInComponent(
        filtersStorageKey,
        defaultFilters,
    );
    const { settingsLoaded, addFilter, emptyFilters } = useSettingsContext(
        filtersStorageKey,
        defaultFilters,
    );

    const canRenderFilters =
        drawable &&
        settingsLoaded !== false &&
        Array.isArray(pageFiltersConfig) &&
        pageFiltersConfig.length > 0;

    return (
        <Box className="dashboard-page-title">
            <h2>{title}</h2>
            {filterSetName && showFilterSetLabel && (
                <Box className="dashboard-page-title-filterset-label">
                    filterSet: {filterSetName}
                </Box>
            )}
            {canRenderFilters && (
                <Box className="dashboard-page-title-filters">
                    {pageFiltersConfig.map((filterId) => (
                        <DashboardFilterRenderer
                            key={filterId}
                            filterId={filterId}
                            t={t}
                            filterModel={filterModel}
                            addFilter={addFilter}
                            filterCatalog={filterCatalog}
                            visibilityUser={filterVisibilityUser}
                        />
                    ))}
                    <Box className="dashboard-page-title-filters-actions">
                        <button
                            type="button"
                            className="dashboard-page-title-clear-filters"
                            onClick={() => {
                                emptyFilters();
                                if (typeof onClearFilters === 'function') {
                                    onClearFilters();
                                }
                            }}
                        >
                            {t('Cancella filtri')}
                        </button>
                        {filterToolbarExtras}
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default DashboardPageTitle;
